import { useEffect, useState } from "react";

import { getSasTokenForTemplateMaster } from "../services/svt/svt-admin/template-management.service";

const useGetSasTokenForTemplateMaster = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchSasToken = async () => {
            try {
                const token = await getSasTokenForTemplateMaster();
                setData(token?.data);
            } catch (error) {
                setData("");
            }
        };
        fetchSasToken();
    }, []);

    return [data];
};

export default useGetSasTokenForTemplateMaster;
